var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7805 20.1C14.7805 18.29 16.0606 17.55 17.6306 18.45C18.5406 18.97 19.7006 18.66 20.2206 17.75L21.2106 16.02C21.6806 15.23 21.4006 14.21 20.6106 13.74L20.4206 13.63C18.8506 12.73 18.8506 11.25 20.4206 10.34L20.6106 10.23C21.4006 9.78 21.6806 8.76 21.2106 7.97L20.2206 6.24C19.7006 5.33 18.5306 5.02 17.6206 5.54C16.0606 6.45 14.7806 5.71 14.7806 3.9C14.7806 2.86 13.9306 2 12.8806 2L11.1206 2C10.0806 2 9.22055 2.85 9.22055 3.9C9.22055 5.71 7.94055 6.45 6.37055 5.54C5.46055 5.02 4.30055 5.33 3.78055 6.24L2.79055 7.97C2.32055 8.76 2.60055 9.78 3.39055 10.25L3.58055 10.36C5.15055 11.26 5.15055 12.74 3.58055 13.65L3.39055 13.76C2.60055 14.23 2.32055 15.25 2.79055 16.04L3.78055 17.77C4.30055 18.68 5.47055 18.99 6.37055 18.47C7.94055 17.56 9.22055 18.3 9.22055 20.11C9.22055 21.15 10.0705 22.01 11.1206 22.01L12.8806 22.01C13.9206 22 14.7805 21.15 14.7805 20.1ZM8.75055 12C8.75055 10.21 10.2106 8.75 12.0006 8.75C13.7906 8.75 15.2506 10.21 15.2506 12C15.2506 13.79 13.7906 15.25 12.0006 15.25C10.2106 15.25 8.75055 13.79 8.75055 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.669902617cc786aad848bf02ee6e052d.svg";
export { ForwardRef as ReactComponent };